import { Link } from "react-router-dom";
import logo_arch from "../assets/images/logo_arch.png";

export default function PageFooter(params) {
    const { navMenuItem } = params;
    const Y = new Date().getFullYear();
    // console.log("footer:", navMenuItem);

    return (
        <footer id="footer">
            <div className="container mb-3">
                <div className="row gx-0">
                    <div
                        id="address"
                        className="col-12 col-md-5 col-lg-4 order-1 mb-4 mb-md-0 text-center"
                    >
                        <div className="row">
                            <div id="image" className="col-12">
                                <img
                                    // src="https://aed.mju.ac.th/arch-lt/images/logo_arch.png"
                                    src={logo_arch}
                                    alt=""
                                    className="mb-lg-3 w-100"
                                />
                            </div>
                            <div id="text" className="col-12 col-lg-12">
                                <p className="text-wrap">
                                    คณะสถาปัตยกรรมศาสตร์และการออกแบบสิ่งแวดล้อม
                                    มหาวิทยาลัยแม่โจ้
                                </p>
                                <p>
                                    เลขที่ 63 หมู่ 4 ถนนเชียงใหม่-พร้าว
                                    ตำบลหนองหาร
                                </p>
                                <p>อำเภอสันทราย จังหวัดเชียงใหม่ 50290</p>
                                <p className="mt-2">
                                    <i className="bi bi-telephone"></i>{" "}
                                    <a href="tel:+66 53 875 350">
                                        +66 53 875 350
                                    </a>{" "}
                                    <span className="d-block d-lg-inline">
                                        <i className="bi bi-envelope ms-lg-3"></i>{" "}
                                        <a href="mailto:archmaejo@gmail.com">
                                            archmaejo@gmail.com
                                        </a>
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div id="footer_links" className="col order-2">
                        <div className="row gx-3 row-cols-1 row-cols-sm-2 row-cols-lg-3">
                            <div className="col">
                                <ul>
                                    <dt>เกี่ยวกับคณะ</dt>
                                    {navMenuItem.about &&
                                        navMenuItem.about.map((item) => (
                                            <li key={`fab-${item.navTitle}`}>
                                                <Link
                                                    to={item.navUrl}
                                                    target="_self"
                                                    rel="noreferrer"
                                                >
                                                    {item.navTitle}
                                                </Link>
                                            </li>
                                        ))}
                                </ul>
                            </div>
                            <div className="col">
                                <ul>
                                    <dt>หลักสูตร</dt>
                                    {navMenuItem.course &&
                                        navMenuItem.course.map((item) => (
                                            <li key={`fco-${item.navTitle}`}>
                                                <Link
                                                    to={item.navUrl}
                                                    target="_self"
                                                    rel="noreferrer"
                                                >
                                                    {item.navTitle}
                                                </Link>
                                            </li>
                                        ))}
                                </ul>
                            </div>
                            <div className="col">
                                <ul>
                                    <dt>บริการ</dt>
                                    {navMenuItem.it &&
                                        navMenuItem.it.map((item) => (
                                            <li key={`fit-${item.navTitle}`}>
                                                <Link
                                                    to={item.navUrl}
                                                    target="_self"
                                                    rel="noreferrer"
                                                >
                                                    {item.navTitle}
                                                </Link>
                                            </li>
                                        ))}
                                    {navMenuItem.download &&
                                        navMenuItem.download.map((item) => (
                                            <li key={`fdl-${item.navTitle}`}>
                                                <Link
                                                    to={item.navUrl}
                                                    target="_self"
                                                    rel="noreferrer"
                                                >
                                                    {item.navTitle}
                                                </Link>
                                            </li>
                                        ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="footer_credits">
                Copyright Faculty of Architecture and Environmental Design,
                Maejo University © {Y}. All rights reserved. Design by{" "}
                <a href="https://m.me/umnarj">umnarj</a>
            </div>
        </footer>
    );
}

export function PageFooter2() {
    console.log("footer2:", navMenuItem);
    const Y = new Date().getFullYear();
    const navMenuItem = {
        about: [
            {
                navTitle: "ประวัติ ความเป็นมา",
                navUrl: "/about/",
            },
            {
                navTitle: "ปรัชญา วิสัยทัศน์และพันธกิจ",
                navUrl: "/about/?p=philosophy",
            },
            {
                navTitle: "ผู้บริหารคณะ",
                navUrl: "/person/adminboard",
            },
            {
                navTitle: "คณาจารย์",
                navUrl: "/person/lecturers",
            },
            {
                navTitle: "เจ้าหน้าที่",
                navUrl: "/person/officers",
            },
            {
                navTitle: "ติดต่อเรา",
                navUrl: "/about/contact.php",
            },
        ],
        course: [
            {
                navTitle: "ป.เอก นวัตกรรมการออกแบบเพื่อความยั่งยืน",
                navUrl: "https://aed.mju.ac.th/arch-dis/",
            },
            {
                navTitle: "ป.โท การวางผังเมืองและสภาพแวดล้อม",
                navUrl: "https://aed.mju.ac.th/arch-murp/",
            },
            {
                navTitle: "ป.โท การออกแบบและวางแผนสิ่งแวดล้อม",
                navUrl: "https://aed.mju.ac.th/arch-av/",
            },
            {
                navTitle: "ป.ตรี สถาปัตยกรรมศาสตร์",
                navUrl: "https://edu-arch.mju.ac.th/wtms_newsDetail.aspx?nID=24651&lang=th-TH",
            },
            {
                navTitle: "ป.ตรี ภูมิสถาปัตยกรรมศาสตร์",
                navUrl: "https://aed.mju.ac.th/arch-la/",
            },
            {
                navTitle: "ป.ตรี เทคโนโลยีภูมิทัศน์",
                navUrl: "https://aed.mju.ac.th/arch-lt/",
            },
        ],
        student: [
            {
                navTitle: "Architron 2022",
                navUrl: "https://www.facebook.com/Architron-2022-104944418948825",
            },
            {
                navTitle: "ปฏิทินกิจกรรม",
                navUrl: "https://arch.mju.ac.th/calendar.php?p=stu",
            },
            {
                navTitle: "ระบบบริการการศึกษา",
                navUrl: "http://reg.mju.ac.th/",
            },
            {
                navTitle: "ศูนย์สอบ ICT",
                navUrl: "https://www.facebook.com/ETestingMaejo/",
            },
            {
                navTitle: "ระบบอีเลินนิ่ง",
                navUrl: "http://coursearch.mju.ac.th/",
            },
            {
                navTitle: "MS WINDOWS",
                navUrl: "https://maejonet.mju.ac.th/wtms_webpageDetail.aspx?wID=1271",
            },
            {
                navTitle: "MS OFFICE 365",
                navUrl: "https://www.office.com/",
            },
        ],
        education: [
            {
                navTitle: "ระดับปริญญาตรี",
                navUrl: "http://www.education.mju.ac.th/www/",
            },
            {
                navTitle: "ระดับปริญญาโท",
                navUrl: "http://www.grad.mju.ac.th/",
            },
            {
                navTitle: "ระดับปริญญาเอก",
                navUrl: "http://www.grad.mju.ac.th/",
            },
        ],
        it: [
            {
                navTitle: "ระบบการจองห้องประชุมคณะฯ",
                navUrl: "https://arch.mju.ac.th/calendar/meetingroom",
            },
            {
                navTitle: "ระบบการจองห้องปฏิบัติการคอมฯ",
                navUrl: "https://arch.mju.ac.th/calendar/lab211",
            },
            {
                navTitle: "ระบบการจองใช้เครื่องยิงเลเซอร์",
                navUrl: "https://arch.mju.ac.th/calendar/lasercut",
            },
            {
                navTitle: "ระบบอีเลินนิ่งของคณะฯ",
                navUrl: "https://coursearch.mju.ac.th/",
            },
        ],
        download: [
            {
                navTitle: "เอกสารงานวิจัย",
                navUrl: "https://drive.google.com/drive/folders/1MGAdq_X2FxXa1TH2eKCr_DTL3m0-DP9Q?usp=sharing",
            },
            {
                navTitle: "เอกสารงานบริการวิชาการ",
                navUrl: "https://drive.google.com/drive/folders/1HlVI0vooVs8lAmCqe5gD49UfuWs7535M?usp=sharing",
            },
        ],
    };
    return (
        <footer id="footer">
            <div className="container mb-3">
                <div className="row gx-0">
                    <div
                        id="address"
                        className="col-12 col-md-5 col-lg-4 order-1 mb-4 mb-md-0 text-center"
                    >
                        <div className="row">
                            <div id="image" className="col-12">
                                <img
                                    // src="https://aed.mju.ac.th/arch-lt/images/logo_arch.png"
                                    src={logo_arch}
                                    alt=""
                                    className="mb-lg-3 w-100"
                                />
                            </div>
                            <div id="text" className="col-12 col-lg-12">
                                <p className="text-wrap">
                                    คณะสถาปัตยกรรมศาสตร์และการออกแบบสิ่งแวดล้อม
                                    มหาวิทยาลัยแม่โจ้
                                </p>
                                <p>
                                    เลขที่ 63 หมู่ 4 ถนนเชียงใหม่-พร้าว
                                    ตำบลหนองหาร
                                </p>
                                <p>อำเภอสันทราย จังหวัดเชียงใหม่ 50290</p>
                                <p className="mt-2">
                                    <i className="bi bi-telephone"></i>{" "}
                                    <a href="tel:+66 53 875 350">
                                        +66 53 875 350
                                    </a>{" "}
                                    <span className="d-block d-lg-inline">
                                        <i className="bi bi-envelope ms-lg-3"></i>{" "}
                                        <a href="mailto:archmaejo@gmail.com">
                                            archmaejo@gmail.com
                                        </a>
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div id="footer_links" className="col order-2">
                        <div className="row gx-3 row-cols-1 row-cols-sm-2 row-cols-lg-3">
                            <div className="col">
                                <ul>
                                    <dt>เกี่ยวกับคณะ</dt>
                                    {navMenuItem.about.map((item) => (
                                        <li key={`fab-${item.navTitle}`}>
                                            <Link
                                                to={item.navUrl}
                                                target="_self"
                                                rel="noreferrer"
                                            >
                                                {item.navTitle}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <div className="col">
                                <ul>
                                    <dt>หลักสูตร</dt>
                                    {navMenuItem.course.map((item) => (
                                        <li key={`fco-${item.navTitle}`}>
                                            <Link
                                                to={item.navUrl}
                                                target="_self"
                                                rel="noreferrer"
                                            >
                                                {item.navTitle}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <div className="col">
                                <ul>
                                    <dt>บริการ</dt>
                                    {navMenuItem.it.map((item) => (
                                        <li key={`fit-${item.navTitle}`}>
                                            <Link
                                                to={item.navUrl}
                                                target="_self"
                                                rel="noreferrer"
                                            >
                                                {item.navTitle}
                                            </Link>
                                        </li>
                                    ))}
                                    {navMenuItem.download.map((item) => (
                                        <li key={`fdl-${item.navTitle}`}>
                                            <Link
                                                to={item.navUrl}
                                                target="_self"
                                                rel="noreferrer"
                                            >
                                                {item.navTitle}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="footer_credits">
                Copyright Faculty of Architecture and Environmental Design,
                Maejo University © {Y}. All rights reserved. Design by{" "}
                <a href="https://m.me/umnarj">umnarj</a>
            </div>
        </footer>
    );
}

export function PageFooterEn() {
    const Y = new Date().getFullYear();
    const navMenuItem = {
        about: [
            {
                navTitle: "History",
                navUrl: "/about/",
            },
            {
                navTitle: "Philosophy",
                navUrl: "/about/?p=philosophy",
            },
            {
                navTitle: "Boards",
                navUrl: "/person/adminboard",
            },
            {
                navTitle: "Lecturers",
                navUrl: "/person/lecturers",
            },
            {
                navTitle: "Staff",
                navUrl: "/person/officers",
            },
            {
                navTitle: "Contact us",
                navUrl: "/about/contact.php",
            },
        ],
        course: [
            {
                navTitle: "Doctor of Design Innovation for Sustainability",
                navUrl: "https://aed.mju.ac.th/arch-dis/",
            },
            {
                navTitle: "Master of Urban and Regional Planning",
                navUrl: "https://aed.mju.ac.th/arch-murp/",
            },
            {
                navTitle:
                    "Master of Science Program in Environmental Design and Planning",
                navUrl: "https://aed.mju.ac.th/arch-av/",
            },
            {
                navTitle: "Bachelor of Architecture Program in Architecture",
                navUrl: "https://edu-arch.mju.ac.th/wtms_newsDetail.aspx?nID=24651&lang=th-TH",
            },
            {
                navTitle: "Bachelor of Landscape Architecture Program",
                navUrl: "https://aed.mju.ac.th/arch-la/",
            },
            {
                navTitle:
                    "Bachelor of Technology Program in Landscape Technology",
                navUrl: "https://aed.mju.ac.th/arch-lt/",
            },
        ],
        education: [
            {
                navTitle: "ระดับปริญญาตรี",
                navUrl: "http://www.education.mju.ac.th/www/",
            },
            {
                navTitle: "ระดับปริญญาโท",
                navUrl: "http://www.grad.mju.ac.th/",
            },
            {
                navTitle: "ระดับปริญญาเอก",
                navUrl: "http://www.grad.mju.ac.th/",
            },
        ],
        it: [
            {
                navTitle: "ระบบการจองห้องประชุมคณะฯ",
                navUrl: "https://arch.mju.ac.th/calendar/meetingroom",
            },
            {
                navTitle: "ระบบการจองห้องปฏิบัติการคอมฯ",
                navUrl: "https://arch.mju.ac.th/calendar/lab211",
            },
            {
                navTitle: "ระบบการจองใช้เครื่องยิงเลเซอร์",
                navUrl: "https://arch.mju.ac.th/calendar/lasercut",
            },
            {
                navTitle: "ระบบอีเลินนิ่งของคณะฯ",
                navUrl: "https://coursearch.mju.ac.th/",
            },
        ],
    };
    return (
        <footer id="footer">
            <div className="container mb-3">
                <div className="row gx-0">
                    <div
                        id="address"
                        className="col-12 col-md-5 col-lg-4 order-1 mb-4 mb-md-0 text-center"
                    >
                        <div className="row">
                            <div id="image" className="col-12">
                                <img
                                    // src="https://aed.mju.ac.th/arch-lt/images/logo_arch.png"
                                    src={logo_arch}
                                    alt=""
                                    className="mb-lg-3 w-100"
                                />
                            </div>
                            <div id="text" className="col-12 col-lg-12">
                                <p className="text-wrap">
                                    Faculty Of Architecture And Environmental
                                    Design, Maejo University
                                </p>
                                <p>
                                    63 Moo 4, Nong Han Subdistrict, San Sai
                                    District,
                                </p>
                                <p>Chiang Mai Province, Postcode 50290</p>
                                <p className="mt-2">
                                    <i className="bi bi-telephone"></i>{" "}
                                    <a href="tel:+66 53 875 350">
                                        +66 53 875 350
                                    </a>{" "}
                                    <span className="d-block d-lg-inline">
                                        <i className="bi bi-envelope ms-lg-3"></i>{" "}
                                        <a href="mailto:archmaejo@gmail.com">
                                            archmaejo@gmail.com
                                        </a>
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div id="footer_links" className="col order-2">
                        <div className="row gx-3 row-cols-1 row-cols-sm-2">
                            <div className="col">
                                <ul>
                                    <dt>About us</dt>
                                    {navMenuItem.about.map((item) => (
                                        <li key={`fab-${item.navTitle}`}>
                                            <Link
                                                to={item.navUrl}
                                                target="_self"
                                                rel="noreferrer"
                                            >
                                                {item.navTitle}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <div className="col">
                                <ul>
                                    <dt>Courses</dt>
                                    {navMenuItem.course.map((item) => (
                                        <li key={`fco-${item.navTitle}`}>
                                            <Link
                                                to={item.navUrl}
                                                target="_self"
                                                rel="noreferrer"
                                            >
                                                {item.navTitle}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="footer_credits">
                Copyright Faculty of Architecture and Environmental Design,
                Maejo University © {Y}. All rights reserved. Design by{" "}
                <a href="https://m.me/umnarj">umnarj</a>
            </div>
        </footer>
    );
}
